import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "salary-overview-app"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "salary-overview-app__column-wrapper" }
const _hoisted_5 = { class: "salary-overview-app__column" }
const _hoisted_6 = { class: "salary-overview-app__statistics-info" }
const _hoisted_7 = {
  key: 0,
  class: "salary-overview-app__statistics-description"
}
const _hoisted_8 = { class: "salary-overview-app__column" }
const _hoisted_9 = { class: "salary-overview-app__statistics-info" }
const _hoisted_10 = {
  key: 0,
  class: "salary-overview-app__statistics-description"
}

import {computed, onBeforeMount, ref} from 'vue';
import {useApi} from '@shared/services/api-service.ts';
import Spinner from '@shared/components/spinner/Spinner.vue';
import Accordion from "@shared/components/Accordion/Accordion.vue";
import SalaryExplanationLink from "@shared/components/salary-explanation-link/SalaryExplanationLink.vue";
import SalaryResultsStatistics from "@shared/components/salary-results-statistics/SalaryResultsStatistics.vue";
import {formatText} from '@shared/utils/format-text';


export default /*@__PURE__*/_defineComponent({
  __name: 'SalaryOverviewApp',
  props: {
    statisticsHeading: {},
    statisticsDescription: {},
    explanationLinkLabel: {},
    explanationLinkUrl: {}
  },
  setup(__props: any) {



const translationApi = useApi('salary/gettranslations');
const statisticsApi = useApi('salary/overview');

const translations = ref<SalaryAppTranslations | null>(null);
const regionStatistics = ref<RegionStatisticsResponse[]>([]);

const loading = computed(() => translationApi.loading.value || statisticsApi.loading.value);

const sortedRegions = computed(() => {
    return [...regionStatistics.value];
});

const splitIndex = computed(() => {
  return Math.ceil(sortedRegions.value.length / 2);
});

const firstRegions = computed(() => {
  return sortedRegions.value.slice(0, splitIndex.value);
});

const secondRegions = computed(() => {
  return sortedRegions.value.slice(splitIndex.value);
});

const toStatistics = (region: RegionStatisticsResponse): SalaryStatisticsValues => ({
  count: region.count,
  average: region.average,
  p10: region.p10,
  median: region.median,
  p90: region.p90,
  hasEnoughData: region.count > 10,
});

onBeforeMount(() => {
  Promise.all([
    translationApi.get<SalaryAppTranslations>(),
    statisticsApi.get<RegionStatisticsResponse[]>(),
  ])
    .then(([salaryTranslations, overview]) => {
      translations.value = salaryTranslations;
      regionStatistics.value = overview;
    })
    .catch((error: unknown) => {
      console.error('Error fetching salary overview data:', error);
    });
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.statisticsHeading)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.statisticsHeading), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.statisticsDescription)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(__props.statisticsDescription), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstRegions.value, (region, index) => {
              return (_openBlock(), _createBlock(Accordion, {
                key: region.region,
                title: _unref(formatText)(region.region),
                defaultExpanded: index === 0,
                toggleRight: true,
                white: true,
                class: "accordion-block--statistics"
              }, {
                default: _withCtx(() => [
                  _createVNode(SalaryResultsStatistics, {
                    statistics: toStatistics(region),
                    values: null,
                    valuesLabel: null,
                    p10Label: translations.value?.p10Label,
                    medianLabel: translations.value?.medianSalaryLabel,
                    averageLabel: translations.value?.averageSalaryLabel,
                    p90Label: translations.value?.p90Label,
                    insufficientDataTitle: translations.value?.insufficientDataOne,
                    insufficientDataText: translations.value?.insufficientDataTwo
                  }, null, 8 /* PROPS */, ["statistics", "p10Label", "medianLabel", "averageLabel", "p90Label", "insufficientDataTitle", "insufficientDataText"]),
                  _createElementVNode("div", _hoisted_6, [
                    (translations.value?.overviewStatisticsDescription)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(translations.value.overviewStatisticsDescription), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode(SalaryExplanationLink, {
                      label: __props.explanationLinkLabel,
                      url: __props.explanationLinkUrl
                    }, null, 8 /* PROPS */, ["label", "url"])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "defaultExpanded"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondRegions.value, (region) => {
              return (_openBlock(), _createBlock(Accordion, {
                key: region.region,
                title: _unref(formatText)(region.region),
                toggleRight: true,
                white: true,
                class: "accordion-block--statistics"
              }, {
                default: _withCtx(() => [
                  _createVNode(SalaryResultsStatistics, {
                    statistics: toStatistics(region),
                    values: null,
                    valuesLabel: null,
                    p10Label: translations.value?.p10Label,
                    medianLabel: translations.value?.medianSalaryLabel,
                    averageLabel: translations.value?.averageSalaryLabel,
                    p90Label: translations.value?.p90Label,
                    insufficientDataTitle: translations.value?.insufficientDataOne,
                    insufficientDataText: translations.value?.insufficientDataTwo
                  }, null, 8 /* PROPS */, ["statistics", "p10Label", "medianLabel", "averageLabel", "p90Label", "insufficientDataTitle", "insufficientDataText"]),
                  _createElementVNode("div", _hoisted_9, [
                    (translations.value?.overviewStatisticsDescription)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(translations.value.overviewStatisticsDescription), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode(SalaryExplanationLink, {
                      label: __props.explanationLinkLabel,
                      url: __props.explanationLinkUrl
                    }, null, 8 /* PROPS */, ["label", "url"])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]))
}
}

})